export default __webpack_public_path__ + "static/media/horizontal1.9cbee601.JPG";